import React from 'react';
import { motion } from 'framer-motion';
import { Settings, Compass, TrendingUp, Puzzle } from 'lucide-react';

const principles = [
  {
    icon: <Settings className="w-6 h-6 text-orcsys-500" />,
    title: "Sur-mesure malin",
    description: "On construit l'essentiel, rien de superflu."
  },
  {
    icon: <Compass className="w-6 h-6 text-orcsys-500" />,
    title: "Focus utilisateur",
    description: "Expérience fluide et claire dès la première interaction."
  },
  {
    icon: <TrendingUp className="w-6 h-6 text-orcsys-500" />,
    title: "Mesurable dès J1",
    description: "Données et feedbacks intégrés."
  },
  {
    icon: <Puzzle className="w-6 h-6 text-orcsys-500" />,
    title: "Évolutif par design",
    description: "Votre prototype peut devenir la base de votre V1."
  }
];

const PhilosophySection = () => {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="container px-4 mx-auto">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Notre philosophie
            </h2>
            <h3 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-6">
              Aller vite, apprendre vite, dépenser juste.
            </h3>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto">
              Chez Orcsys, nous ne faisons pas de "maquettes jolies".
              Nous concevons des prototypes qui prouvent : chaque écran sert une hypothèse, chaque clic révèle une donnée, chaque livrable raconte une histoire claire.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {principles.map((principle, index) => (
              <motion.div
                key={index}
                className="bg-slate-50 rounded-xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:scale-[1.02] transition-all duration-300 border border-slate-100"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="flex flex-col items-center text-center h-full">
                  <div className="flex flex-col items-center mb-3">
                    <div className="w-12 h-12 rounded-lg bg-orcsys-50 flex items-center justify-center mb-2">
                      {principle.icon}
                    </div>
                    <h4 className="text-lg font-semibold text-slate-900">
                      {principle.title}
                    </h4>
                  </div>
                  <p className="text-slate-600 leading-relaxed">
                    {principle.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;

